import * as t from 'io-ts'
import { Breakdown } from '../../02-molecules/admin-player-matcher-table-row-item'

export const AdminPlayerBreakdownRows = t.array(Breakdown)

export type AdminPlayerBreakdownRows = t.TypeOf<typeof AdminPlayerBreakdownRows>

export type ComponentProps = {
  allRows: AdminPlayerBreakdownRows
}